import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const IST_TZ = "Asia/Kolkata";

export const nowIST = (): Dayjs => dayjs().tz(IST_TZ);

export const toIST = (value: Dayjs): Dayjs => dayjs(value).tz(IST_TZ);

export const ADVANCE_LEAD_MS = 2 * 60 * 1000;
export const DELAYED_AFTER_MS = 15 * 60 * 1000;

const parseBookedMs = (value?: string | null): number | null => {
    if (!value) return null;
    const ms = new Date(value).getTime();
    return Number.isNaN(ms) ? null : ms;
};

export const isAdvanceBooking = (
    bookedtime?: string | null,
    nowMs: number = Date.now()
): boolean => {
    const ms = parseBookedMs(bookedtime);
    return ms !== null && ms - nowMs > ADVANCE_LEAD_MS;
};

export const isDelayedBooking = (
    bookedtime?: string | null,
    nowMs: number = Date.now()
): boolean => {
    const ms = parseBookedMs(bookedtime);
    return ms !== null && nowMs - ms >= DELAYED_AFTER_MS;
};

export const buildDatePayload = (
    fromDate: Dayjs,
    toDate: Dayjs,
    format = "YYYY-MM-DD"
) => {
    return {
        fromDate: fromDate.format(format),
        toDate: toDate.format(format),
    };
};
